import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Flex from '@wix/da-ds/pkg/Flex';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { SessionContext } from '@wix/da-react-context/pkg/SessionContext';
import ThreadOrderSelect from '../ThreadOrderSelect';
import s from './ThreadHeader.scss';
const ThreadHeader = ({ total, commentableTypeId, commentableItemId, parentId, withOrder = true, withTitle = true, children, className })=>{
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const { isLoggedIn } = useContext(SessionContext);
    if (!withOrder && !withTitle) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Flex, {
        className: className,
        alignItems: "center",
        dataHook: BiDataHook.COMMENTS_THREAD_STATS
    }, /*#__PURE__*/ React.createElement("div", {
        "data-hook": BiDataHook.COMMENTS_THREAD_COUNT
    }, withTitle && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("span", {
        className: s['title']
    }, t('commentthread.control.comments')), total !== undefined && /*#__PURE__*/ React.createElement("span", {
        className: s['total']
    }, total))), !isMobile && /*#__PURE__*/ React.createElement(React.Fragment, null, children), withOrder && isLoggedIn && /*#__PURE__*/ React.createElement(ThreadOrderSelect, {
        commentableItemId: commentableItemId,
        commentableTypeId: commentableTypeId,
        parentId: parentId
    })), isMobile && /*#__PURE__*/ React.createElement(Flex, null, children));
};
ThreadHeader.displayName = 'ThreadHeader';
export default ThreadHeader;
